var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarcier({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 0L11.6374 0.537491C8.6515 4.88484 4.88335 8.65299 0.536005 11.6389L0 12.0007L0.536005 12.3626C4.88335 15.3485 8.6515 19.1166 11.6374 23.464L11.9993 24L12.3611 23.464C15.347 19.1166 19.1152 15.3485 23.4625 12.3626L24 12.0007L23.4625 11.6389C19.1152 8.65299 15.347 4.88484 12.3611 0.537491L11.9993 0Z",
    fill: "#161717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarcier);
export default __webpack_public_path__ + "static/media/starcier.1bd87333b9f099615d4eaa373a5cb6cd.svg";
export { ForwardRef as ReactComponent };